import React from "react";
import { Link } from "react-router-dom";

import caseStudies from "../../data/caseStudies";

import SectionContainer from "../common/SectionContainer";
import SectionTitle from "../common/SectionTitle";

import CaseStudyCard from "../cards/CaseStudyCard";

function CaseStudiesPreview() {
  const featuredStudies =
    caseStudies.filter(
      (study) => study.featured
    );

  return (
    <SectionContainer background="#f8fafc">
      <SectionTitle
        title="Featured Case Studies"
        subtitle="Real-world growth strategies designed to solve business challenges and improve outcomes."
      />

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit,minmax(340px,1fr))",
          gap: "28px"
        }}
      >
        {featuredStudies.map((study) => (
          <CaseStudyCard
            key={study.slug}
            study={study}
          />
        ))}
      </div>

      <div
        style={{
          textAlign: "center",
          marginTop: "50px"
        }}
      >
        <Link
          to="/case-studies"
          style={{
            color: "#21b573",
            textDecoration: "none",
            fontWeight: 700
          }}
        >
          View All Case Studies →
        </Link>
      </div>
    </SectionContainer>
  );
}

export default CaseStudiesPreview;